<button
  [ngClass]="{ 'not-allowed': !(state | async).resetFiltersPossibility }"
  [disabled]="!(state | async).resetFiltersPossibility"
  class="uk-button uk-button-danger uk-button-small list-view-action-button uk-margin-small-left"
  (click)="resetFilters()"
  i18n="@@ResetFilters">
  Reset filters
</button>
